import { Icons, Images } from "assets";
import classNames from "classnames";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import CustomButton from "shared/components/common/customButton";
import CustomInput from "shared/components/common/customInput";
import { routeConstant } from "shared/routes/routeConstant";
import { ForgotPasswordVS } from "shared/utils/validation";
import styles from "./styles.module.scss";
import { ForgotPasswordService } from "shared/services/auth";
import { toastMessage } from "shared/components/common/toast";

const initialValues: ForgotPasswordType = {
  email: "",
};

const ForgotPassword = () => {
  const navigate = useNavigate();

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: ForgotPasswordVS,
    onSubmit: (value, action) => {
      handleForgotPassword();
    },
  });

  const {
    handleChange,
    handleSubmit,
    values,
    touched,
    errors,
    isSubmitting,
    setSubmitting,
    resetForm,
  } = formik;

  const handleForgotPassword = () => {
    setSubmitting(true);
    ForgotPasswordService(values)
      .then(() => {
        toastMessage(
          "success",
          "Your password reset request has been sent to your email"
        );
        resetForm();
      })
      .catch((err) => {
        toastMessage("error", err?.response?.data?.error);
      })
      .finally(() => {
        setSubmitting(false);
      });
  };

  return (
    <main className={styles.bg}>
      <div className={classNames(styles.customContainer)}>
        <div className={classNames(styles.mainContainer, "py-5")}>
          <section
            className={classNames(
              "w-full lg:w-1/2 flex flex-col items-center  relative ",
              styles.leftContainer
            )}
          >
            <Link
              to={routeConstant.home.path}
              className={classNames(styles.logoContainer)}
            >
              <Icons.Logo />
            </Link>
            <div
              className={classNames(
                "flex items-center w-full justify-center m-auto"
              )}
            >
              <form
                className={classNames(styles.formContainer)}
                onSubmit={(e) => {
                  e.preventDefault();
                }}
              >
                <div className={classNames("flex flex-col items-start gap-3")}>
                  <h1 className={classNames(styles.title)}>Forgot Password</h1>
                  <p className={classNames(styles.subTitle)}>
                    No worries, we’ll send you reset instructions.
                  </p>
                </div>
                <div className={classNames("flex flex-col gap-1")}>
                  <CustomInput
                    label="Enter your email"
                    placeholder="Enter your email"
                    required
                    Icon={Icons.Mail}
                    type="email"
                    value={values.email}
                    error={touched.email && errors.email ? errors.email : ""}
                    onChange={handleChange("email")}
                    customLabelStyle={classNames(styles.labelStyle)}
                  />
                </div>
                <div className={classNames("flex flex-col items-center gap-6")}>
                  <CustomButton
                    title="Send Reset Request"
                    style={{ width: "100%" }}
                    onClick={() => handleSubmit()}
                    loading={isSubmitting}
                    disabled={isSubmitting}
                  />
                  <label
                    className={classNames(styles.bottomText, "gap-1")}
                    onClick={() => {
                      navigate(-1);
                    }}
                  >
                    <Icons.ArrowLeft /> Back to Login
                  </label>
                </div>
              </form>
            </div>
          </section>
          <section
            className={classNames(
              "w-1/2 hidden lg:flex relative flex-col justify-between overflow-hidden",
              styles.rightContainer
            )}
          >
            <div
              className={classNames(
                "flex flex-col items-start gap-3 px-5 py-10 justify-center"
              )}
            >
              <h1 className={classNames(styles.title)}>
                Access Your <span>Job Evaluation</span> Portal
              </h1>
              <p className={classNames(styles.subTitle)}>
                Sign in to your account to evaluate jobs, 
                manage existing evaluations, collaborate with other users, and request support from CGP. 
                <br></br>Our platform is designed to simplify the job evaluation process.
              </p>
            </div>
            <img
              src={Images.LoginPlaceholder}
              alt=""
              className={classNames(styles.assetImg)}
            />
          </section>
        </div>
      </div>
    </main>
  );
};

export default ForgotPassword;
